import { Component, ElementRef, inject, OnInit, Renderer2, viewChild } from '@angular/core';
import { RadarChartComponent } from '../../../../core/shared/ui/radar-chart/radar-chart.component';
import { Subject } from 'rxjs';
import { AuthUser } from '../../../../core/models/auth/auth.interface';
import { User } from '../../../../core/models/user.interface';
import { TestsService } from '../../../../core/services/tests.service';
import { AuthService } from '../../../../core/services/auth.service';
import { CommonModule } from '@angular/common';
import ApexCharts from 'apexcharts';

@Component({
  selector: 'app-circle-life',
  standalone: true,
  imports: [RadarChartComponent, CommonModule],
  templateUrl: './circle-life.component.html',
  styleUrl: './circle-life.component.scss'
})
export class CircleLifeComponent implements OnInit {
  private authService = inject(AuthService);
  private testService = inject(TestsService);

  authUser: AuthUser = this.authService.getAuthUser()!;
  user!: User;

  isLoading = true;
  currentStep = 3;
  series: any[] = [];
  seriesApply: any[] = [];
  categories: string[] = [];
  testHoyColor = "#00D15A";
  testFuturoColor = "#ce0024";
  colors: string[] = [this.testHoyColor, this.testFuturoColor];
  barChartInstance: any;

  barChart = viewChild<ElementRef>("barChart")

  optionSelected = 0;
  summary: any;

  eventsSubject: Subject<void> = new Subject<void>();

  constructor(private renderer: Renderer2) {}

  async ngOnInit(): Promise<void> {
    this.getTests();
  }

  async createBarChart() {
    var options = {
      series: this.seriesApply,
      chart: {
        type: 'bar',
        height: 430,
        toolbar: {
          show: false,
        },
      },
      colors: ['#00D15A', '#ce0024'],
      plotOptions: {
        bar: {
          horizontal: true,
          dataLabels: {
            position: 'top',
          },
        }
      },
      dataLabels: {
        enabled: true,
        offsetX: -6,
        style: {
          fontSize: '12px',
          colors: ['#fff']
        }
      },
      stroke: {
        show: true,
        width: 1,
        colors: ['#fff']
      },
      tooltip: {
        shared: true,
        intersect: false
      },
      xaxis: {
        categories: this.categories,
        max: 10,
        labels: {
          style: {
            fontSize: '12px',
            whiteSpace: 'normal',
          },
        }
      },
      legend: {
        show: false
      },
    };
    if (this.barChartInstance) {
      await this.barChartInstance.destroy();
    }
    this.barChartInstance = new ApexCharts(this.barChart()?.nativeElement, options);
    this.barChartInstance.render();
  }

  showOnlyFirstColor() {
    const colors = ['#00D15A'];
    this.updateBarChart(colors);
  }
  
  showOnlySecondColor() {
    const colors = ['#ce0024'];
    this.updateBarChart(colors);
  }
  
  showBothColors() {
    const colors = ['#00D15A', '#ce0024'];
    this.updateBarChart(colors);
  }
  
  updateBarChart(colors: string[]) {
    if (this.barChartInstance) {
      this.barChartInstance.updateSeries(this.seriesApply, colors);
    }
  }
  

  getTests(): void {
    this.testService.find(this.authUser.id).subscribe({
      next: (res: any) => {
        if (res.data !== null) {
          let tests = res.data.filter((x: any) => x.type.id == 2 || x.type.id == 3);

          tests = tests.sort((a: any, b: any) => a.type.id - b.type.id);

          tests.forEach((item: any) => {
            item.questions = item.questions.slice().sort((a: any, b: any) => a.dimension.name.localeCompare(b.dimension.name));
          });

          this.series = tests.map((x: any) => ({
            name: x.type.name,
            data: x.questions.map((q: any) => q.answer && q.answer.value ? parseInt(q.answer.value) : 0),
            dimensions: x.questions.map((q: any) => q.dimension)
          }));
          this.categories = tests.find((x: any) => x.type.id == 2).questions.map((q: any) => q.dimension.name);

          this.seriesApply = this.series;

          this.createBarChart();

        }
      },
      error: (err: any) => {
        console.log('err', err);
      }
    });
  }

  showSummary(index: number): void {
    this.summary = {
      title: this.categories[index],
      details: this.seriesApply.map(x => ({ name: x.name, value: x.data[index], max: 10 }))
    };

  }

  async showChartLegend(option: number) {
    this.optionSelected = option;
    switch (option) {
      case 0:
        this.seriesApply.forEach(s => s.hidden = false);
        console.log('this.seriesApply', this.seriesApply);
        this.showBothColors();
        break;
      case 1:
        this.seriesApply[0].hidden = false;
        this.seriesApply[1].hidden = true;
        console.log('this.seriesApply', this.seriesApply);
        this.showOnlyFirstColor();
        break;
      case 2:
        this.seriesApply[0].hidden = true;
        this.seriesApply[1].hidden = false;
        console.log('this.seriesApply', this.seriesApply);
        this.showOnlySecondColor();
        break;
    }
    this.eventsSubject.next();
  }
}
